import React from "react";
import type { LinkProps } from "../Link";
import Link from "../Link";
import { colors, fonts } from "../Theme";
import { css } from "@linaria/core";
import cx from "classnames";

export const ACTIVE_CN = "active";
export const DISABLED_CN = "disabled";

interface TabProps extends LinkProps {
  //   subtab?: boolean;
  disabled?: boolean;
  theme?: "light" | "dark";
  children: React.ReactNode;
}

const TabItem = css`
  font: ${fonts.body1};
  padding: 10px 16px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  /* opacity: 0.7; */
  font-weight: 500;
  transition: opacity 150ms;

  &.light {
    color: ${colors.carbon700};

    &.active:not(.${DISABLED_CN}) {
      color: ${colors.lightNitrogen500_Main};
    }

    &:hover:not(.active):not(.${DISABLED_CN}) {
      color: ${colors.carbon900};
    }
  }

  &.dark {
    color: ${colors.hydrogenFade30};
    &.active:not(.${DISABLED_CN}),
    &:hover:not(.${DISABLED_CN}) {
      color: ${colors.hydrogen};
    }
  }

  &.${DISABLED_CN} {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

const Tab = ({ disabled, theme = "light", className, children, ...props }: TabProps) => (
  <Link
    tabIndex={-1}
    className={cx(
      TabItem,
      theme,
      { [DISABLED_CN]: disabled } /* { [tabCSS]: !subtab, [subtabCSS]: subtab } */,
      className,
    )}
    onClick={e => {
      if (disabled) {
        e.preventDefault();
        e.stopPropagation();
      }
    }}
    {...props}
  >
    {children}
  </Link>
);

export default Tab;
